export default "__VITE_ASSET__be80972b__"